import React from "react"
import clsx from "clsx"

import {
  attachmentKind,
  attachmentTypeLabel,
  CopilotAttachmentMeta,
  formatAttachmentSize,
} from "./copilotAttachments"

import styles from "./CopilotStudioSdkChat.module.sass"

type Props = {
  attachment: CopilotAttachmentMeta
  /** Composer only: a sent message's attachments cannot be removed. */
  onRemove?: () => void
  disabled?: boolean
}

const CopilotAttachmentCard: React.FC<Props> = ({
  attachment,
  onRemove,
  disabled,
}) => {
  const kind = attachmentKind(attachment)
  const typeLabel = attachmentTypeLabel(attachment)
  const size = formatAttachmentSize(attachment.size)
  const details = [typeLabel, size].filter(Boolean).join(" · ")

  return (
    <div
      className={styles.attachmentCard}
      title={attachment.name}
      aria-label={`Attachment: ${attachment.name}, ${details}`}
    >
      <span
        className={clsx(styles.attachmentBadge, styles[`attachment_${kind}`])}
        aria-hidden
      >
        {typeLabel.slice(0, 4)}
      </span>
      <span className={styles.attachmentText}>
        <span className={styles.attachmentName}>{attachment.name}</span>
        <span className={styles.attachmentMeta}>{details}</span>
      </span>
      {onRemove ? (
        <button
          type="button"
          className={styles.attachmentRemove}
          onClick={onRemove}
          disabled={disabled}
          aria-label={`Remove ${attachment.name}`}
        >
          ×
        </button>
      ) : null}
    </div>
  )
}

export default CopilotAttachmentCard
